import { createApp } from 'vue';
import VueCookies from 'vue-cookies';
import { createRouter, createWebHashHistory } from 'vue-router';
import axios from 'axios';

import App from './App.vue'
import NotificationsPage from './components/NotificationsPage.vue'
import WhatsAppCoaching from './components/WhatsAppCoaching.vue'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
})

const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{
			path: '/', component: NotificationsPage,
			meta: {
				hideNavbar: true,
				hideFooter: true
			}
		},
		{
			path: '/notifications', component: NotificationsPage,
			meta: {
				hideNavbar: true,
				hideFooter: true
			}
		},
		{
			path: '/whatsappcoaching', component: WhatsAppCoaching,
			meta: {
				hideNavbar: true,
				hideFooter: true
			}
		},
	]
});

const app = createApp(App);
app.config.globalProperties.$http = axios;
app.use(VueCookies);
app.use(router);
app.use(vuetify);
app.mount("#app");
